import React from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { fetchDashboardCountRequest } from "../ipsStore/actions";
import GenericDashboardScreen from "../components/GenericDashboardScreen";
import MedicalOpinionIcon from "../../../assets/images/MedicalOpinion.svg";
import DashboardBG from "../../../assets/images/Dashboard_bg.svg";

const MedicalOpinion = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleCardClick = (label) => {
    navigate(
      `/medical_opinion-patient_list?label=${encodeURIComponent(label)}`,
      {
        state: { label },
      }
    );
  };

  const handleDateFilterApply = (dateRange) => {
    let payload = new FormData();
    payload.append("from_date", dateRange.fromDate);
    payload.append("to_date", dateRange.toDate);
    payload.append("screen", "medical_opinion");
    payload.append("source", "Web");
    dispatch(fetchDashboardCountRequest(payload));
  };

  return (
    <GenericDashboardScreen
      header="Medical Opinion"
      screenIcon={MedicalOpinionIcon}
      iconUrl={"/home"}
      showDateFilters={true}
      bgImage={DashboardBG}
      fetchAction={fetchDashboardCountRequest}
      dataSelector={(state) => state.ips.dashboardCount?.medical_opinion}
      screenName="medical_opinion"
      handleCardClick={handleCardClick}
      dateFilterHandler={handleDateFilterApply}
    />
  );
};

export default MedicalOpinion;
